export function formatRuleId(type: string) {
  return type.split('_').join(' ').toUpperCase();
}
